import { Controller } from "@hotwired/stimulus"
import { patch } from "@lib/requests"

// Connects to data-controller="task-row"
export default class extends Controller {

  static values = { id: Number }
  
  toggle(event) {
    const path = `/taches/${this.idValue}/toggle`
    patch(path, { responseKind: "turbo-stream" })
  }
  
}
